import L from 'leaflet';

let iconsFixed = false;

/** Fix Leaflet default marker paths when bundled with webpack/cra. */
export function fixLeafletIcons() {
  if (iconsFixed) return;
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  });
  iconsFixed = true;
}

export const DEFAULT_MAP_CENTER = { lat: -1.286389, lng: 36.817223 };
export const DEFAULT_MAP_ZOOM = 12;
